/* @flow */

import Immutable from 'immutable';
import { MapConstants } from '../constants/map_constants';
import { SharedConstants } from '../constants/shared_constants';

const mapInitialState = Immutable.Map({
  viewport: Immutable.Map({}),
  marker: Immutable.Map({
    hoverId: null,
  }),
  popup: Immutable.Map({}),
  actions: Immutable.OrderedMap({}),
});

function mapReducer(state: Immutable.Map = mapInitialState, action: Object): Immutable.Map {
  switch (action.type) {
    case SharedConstants.SHARED_PURGE: {
      return mapInitialState;
    }

    case MapConstants.MAP_SET_VIEWPORT: {
      return state.set('viewport', state.get('viewport').merge(action.viewport));
    }
    case MapConstants.MAP_SET_CENTER: {
      return state.setIn(['viewport', 'center'], action.center);
    }
    case MapConstants.MAP_SET_LONGITUDE: {
      return state.setIn(['viewport', 'longitude'], action.longitude);
    }
    case MapConstants.MAP_SET_ZOOM: {
      return state.setIn(['viewport', 'zoom'], action.zoom);
    }
    case MapConstants.MAP_SET_BEARING: {
      return state.setIn(['viewport', 'bearing'], action.bearing);
    }
    case MapConstants.MAP_SET_PITCH: {
      return state.setIn(['viewport', 'pitch'], action.pitch);
    }
    case MapConstants.MAP_SET_MARKER_HOVER: {
      return state.setIn(['marker', 'hoverId'], action.hoverId);
    }
    case MapConstants.MAP_SET_POPUP: {
      return state.set('popup', Immutable.Map({
        longitude: action.longitude,
        latitude: action.latitude,
        feature: action.feature,
      }));
    }
    case MapConstants.MAP_CLEAR_POPUP: {
      return state.set('popup', Immutable.Map({}));
    }
    case MapConstants.MAP_ADD_ACTION: {
      return state.setIn(['actions', action.id], Immutable.Map({
        actionType: action.actionType,
        params: action.params
      }));
    }
    case MapConstants.MAP_DELETE_ACTIONS: {
      action.ids.forEach(id => {
        state = state.deleteIn(['actions', id]);
      });
      return state;
    }
  }
  return state;
}

export {
  mapInitialState,
  mapReducer
};
